var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFt5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#DB0035",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5714 9.42857C11.7036 9.42857 11 10.1321 11 11C11 11.8679 11.7036 12.5714 12.5714 12.5714C13.4393 12.5714 14.1429 11.8679 14.1429 11C14.1429 10.1321 13.4393 9.42857 12.5714 9.42857ZM9.57143 11C9.57143 9.34314 10.9146 8 12.5714 8C14.2283 8 15.5714 9.34314 15.5714 11C15.5714 11.917 15.16 12.7379 14.5117 13.2881C15.5415 13.7716 16.3615 14.6278 16.7978 15.6831C16.6508 15.9355 16.5364 16.2094 16.4606 16.4988C15.236 16.8797 14.3468 18.022 14.3468 19.372V22.3973C14.3468 22.7946 14.4239 23.1741 14.5639 23.5213C14.5187 23.7965 14.2806 24 14 24H11.1429C10.8565 24 10.6143 23.788 10.5764 23.5041L10.0711 19.7143H8.57143C8.25584 19.7143 8 19.4584 8 19.1429V17.4286C8 15.5975 9.0765 14.0179 10.6311 13.2881C9.98284 12.7379 9.57143 11.917 9.57143 11ZM19.5829 16.9054C19.357 16.9054 19.1739 17.0886 19.1739 17.3144V17.6122H20.4553V17.3144C20.4553 17.0886 20.2722 16.9054 20.0463 16.9054H19.5829ZM17.7453 17.3144V17.6122H17.338C16.3961 17.6122 15.6326 18.3757 15.6326 19.3176V22.2911C15.6326 23.233 16.3961 23.9966 17.338 23.9966H22.2937C23.2357 23.9966 23.9992 23.233 23.9992 22.2911V19.3176C23.9992 18.3757 23.2357 17.6122 22.2937 17.6122H21.8839V17.3144C21.8839 16.2996 21.0612 15.4769 20.0463 15.4769H19.5829C18.568 15.4769 17.7453 16.2996 17.7453 17.3144ZM17.338 19.0408C17.1851 19.0408 17.0611 19.1647 17.0611 19.3176V22.2911C17.0611 22.444 17.1851 22.568 17.338 22.568H22.2937C22.4466 22.568 22.5706 22.444 22.5706 22.2911V19.3176C22.5706 19.1647 22.4466 19.0408 22.2937 19.0408H17.338Z",
    fill: "#DB0035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt5);
export default __webpack_public_path__ + "static/media/ft_5.8b779c293a9341bd86fb7740d6329316.svg";
export { ForwardRef as ReactComponent };